export enum StaffelTabs {
	GASOLINE = "GasolineStaffel",
	WATER_LEVEL = "WaterLevelStaffel",
	FEET = "FeetStaffel"
}
